import Controller from '@ember/controller'
import {
  updateSortColumns,
  deserialize as deserializeSort,
  serialize as serializeSort,
} from '@blakeelearning/data-tables/utils/sorting'
import { tracked } from '@glimmer/tracking'

export default class FastPhonicsReportingProgressReviewStudentsController extends Controller {
  queryParams = ['sort']

  @tracked sort = 'lesson'

  get sortingConfig() {
    return deserializeSort(this.sort)
  }

  set sortingConfig(newSortingConfig) {
    this.sort = serializeSort(newSortingConfig)
  }

  updateSorts = ({ sortKey }: SortObject) => {
    if (sortKey) {
      const newSortConfig = updateSortColumns(this.sortingConfig, sortKey as string)
      this.sortingConfig = newSortConfig
    }
  }
}
